import { COLORS } from 'helpers/globals'
import { column } from 'helpers/styles/grid'

const buttonDefault = {
    float: 'right',
    marginRight: '1rem'
  }

export default {
  labelDetails: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 435,
    height: '100%',
    overflowY: 'auto',
    padding: 0
  },
  topUiControls: {
    fontSize: '1.6rem',
    padding: '.5rem',
    backgroundColor: COLORS.tertiary,
    borderBottom: `1px solid ${COLORS.quaternary}`
  },
  container: {
    padding: '.8rem',
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  },
  labelTextInput: {
    width: '82% !important'
  },
  labelActions: {
    position: 'absolute',
    right: '1rem',
    top: '1.4rem',
    zIndex: 1
  },
  goBackButton: {
    marginRight: 7
  },
  targetButton: {
    fontSize: '2rem',
    ...buttonDefault,
    lineHeight: '2rem'
  },
  lockButton: {
    ...buttonDefault,
    marginRight: 0,
    lineHeight: '2rem',
    fontSize: '2rem'
  },
  destroyLabelButton: {
    color: 'red',
    fontSize: '1.9rem',
    ...buttonDefault
  },
  sliderContainer: {
    width: '75%'
  },
  label: {
    lineHeight: '3.5rem',
    ...column,
    padding: '0!important',
    marginRight: '0!important',
    color: 'black',
    flex: '0 0 15%',
    maxWidth: '15%'
  },
  textWrapper: {
    ...column,
    position: 'relative',
    padding: '0!important',
    margin: 'auto'
  },
  colorLabel: {
    color: 'black',
    width: '5rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/LabelDetails/style.js